// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import { useTranslation as useI18nTranslation } from 'react-i18next';

// const resources = {
//   ua: { translation: {} },
//   en: { translation: {} },
//   ru: { translation: {} },
//   pl: { translation: {} },
//   de: { translation: {} },
//   es: { translation: {} },
// };

// const savedLanguage = localStorage.getItem('preferredLanguage');

// let initialLanguage = savedLanguage;

// if (!initialLanguage) {
//   const browserLang = navigator.language?.split('-')[0];

//   const langMap = {
//     uk: 'ua',
//     en: 'en',
//     ru: 'ru',
//     pl: 'pl',
//     de: 'de',
//     es: 'es',
//   };
  
//   initialLanguage = langMap[browserLang] || 'en';
// }

// i18n.use(initReactI18next).init({
//   resources,
//   lng: initialLanguage,
//   fallbackLng: 'en',
//   interpolation: { escapeValue: false },
//   ns: ['translation'],
//   defaultNS: 'translation'
// });

// export const addTranslations = (translations) => {
//   Object.keys(translations).forEach(lang => {
//     i18n.addResourceBundle(lang, 'translation', translations[lang], true, true);
//   });
// };

// export default i18n;

// export const supportedLanguages = [
//   { code: 'ua', name: 'Українська', nativeName: 'Українська' },
//   { code: 'en', name: 'English', nativeName: 'English' },
//   { code: 'ru', name: 'Russian', nativeName: 'Русский' },
//   { code: 'de', name: 'German', nativeName: 'Deutsch' },
//   { code: 'pl', name: 'Polish', nativeName: 'Polski' },
//   { code: 'es', name: 'Spanish', nativeName: 'Español' }
// ];

// export const defaultLanguage = 'en';
// export const fallbackLanguage = 'en';

// export const namespaces = {
//   COMMON: 'common',
//   HOME: 'home',
//   ABOUT: 'about',
//   WORK: 'work',
//   NAVIGATION: 'navigation',
//   FOOTER: 'footer'
// };

// export const isValidLanguage = (lang) => {
//   const supportedLanguages = ['ua', 'en', 'ru', 'pl', 'de', 'es'];
//   return supportedLanguages.includes(lang);
// };

// export const validateTranslations = (translations) => {
//   const requiredKeys = ['ua', 'en', 'ru', 'pl', 'de', 'es'];
//   return requiredKeys.every(key => translations.hasOwnProperty(key));
// };

// export const generateArticleSlug = (titleObj) => {
//     if (!titleObj) return '';
    
//     const title = typeof titleObj === 'object' 
//         ? titleObj.en || titleObj.ua || ''
//         : titleObj;
    
//     if (!title) return '';
    
//     return title
//         .toLowerCase()
//         .trim()
//         .replace(/\s*-\s*/g, '-')
//         .replace(/[^a-z0-9-]+/g, '-')
//         .replace(/-+/g, '-')
//         .replace(/^-+/, '')
//         .replace(/-+$/, '');
// };

// export const useTranslation = (ns) => {
//   const { t, i18n, ready } = useI18nTranslation(ns);
  
//   return {
//     t,
//     i18n,
//     ready,
//     currentLanguage: i18n.language
//   };
// };





import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { useTranslation as useI18nTranslation } from 'react-i18next';

const getLanguageFromURL = () => {
  if (typeof window === 'undefined') return null;
  const path = window.location.pathname;
  const match = path.match(/^\/(ua|en|ru|pl|de|es)/);
  return match ? match[1] : null;
};

const resources = {
  ua: { translation: {} },
  en: { translation: {} },
  ru: { translation: {} },
  pl: { translation: {} },
  de: { translation: {} },
  es: { translation: {} },
};

const urlLang = getLanguageFromURL();
const savedLanguage = localStorage.getItem('preferredLanguage');

let initialLanguage;

if (urlLang) {
  initialLanguage = urlLang;
  if (savedLanguage !== urlLang) {
    localStorage.setItem('preferredLanguage', urlLang);
  }
} else if (savedLanguage) {
  initialLanguage = savedLanguage;
} else {
  const browserLang = navigator.language?.split('-')[0];
  const langMap = {
    uk: 'ua',
    en: 'en',
    ru: 'ru',
    pl: 'pl',
    de: 'de',
    es: 'es',
  };
  initialLanguage = langMap[browserLang] || 'en';
  localStorage.setItem('preferredLanguage', initialLanguage);
}

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  ns: ['translation'],
  defaultNS: 'translation'
});

if (typeof window !== 'undefined') {
  const syncLanguageWithURL = () => {
    const pathLang = getLanguageFromURL();
    if (pathLang && i18n.language !== pathLang) {
      i18n.changeLanguage(pathLang);
      localStorage.setItem('preferredLanguage', pathLang);
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncLanguageWithURL);
  } else {
    syncLanguageWithURL();
  }
}

export const addTranslations = (translations) => {
  Object.keys(translations).forEach(lang => {
    i18n.addResourceBundle(lang, 'translation', translations[lang], true, true);
  });
};

export default i18n;

export const supportedLanguages = [
  { code: 'ua', name: 'Українська', nativeName: 'Українська' },
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'pl', name: 'Polish', nativeName: 'Polski' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' }
];

export const defaultLanguage = 'en';
export const fallbackLanguage = 'en';

export const namespaces = {
  COMMON: 'common',
  HOME: 'home',
  ABOUT: 'about',
  WORK: 'work',
  NAVIGATION: 'navigation',
  FOOTER: 'footer'
};

export const isValidLanguage = (lang) => {
  const supportedLanguages = ['ua', 'en', 'ru', 'pl', 'de', 'es'];
  return supportedLanguages.includes(lang);
};

export const validateTranslations = (translations) => {
  const requiredKeys = ['ua', 'en', 'ru', 'pl', 'de', 'es'];
  return requiredKeys.every(key => translations.hasOwnProperty(key));
};

export const generateArticleSlug = (titleObj) => {
    if (!titleObj) return '';
    
    const title = typeof titleObj === 'object' 
        ? titleObj.en || titleObj.ua || ''
        : titleObj;
    
    if (!title) return '';
    
    return title
        .toLowerCase()
        .trim()
        .replace(/\s*-\s*/g, '-')
        .replace(/[^a-z0-9-]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
};

export const useTranslation = (ns) => {
  const { t, i18n, ready } = useI18nTranslation(ns);
  
  return {
    t,
    i18n,
    ready,
    currentLanguage: i18n.language
  };
};